import React from "react";

const ContactUs = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Contact Us</h1>

      <p style={styles.paragraph}>
        We’re here to help you get the most out of Headway Spot.
      </p>

      <p style={styles.paragraph}>
        If you have questions about the product, billing, integrations, or need
        support, feel free to reach out to us.
      </p>

      <p style={styles.paragraph}>
        <strong>Email:</strong> support@headwayspot.com
      </p>

      <p style={styles.paragraph}>
        <strong>Website:</strong> https://www.headwayspot.com
      </p>

      <p style={styles.paragraph}>
        <strong>Business Hours:</strong> Monday – Friday, 10:00 AM – 6:00 PM (IST)
      </p>

      <p style={styles.paragraph}>
        We typically respond within 24–48 business hours.
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "40px 20px",
    lineHeight: "1.7",
    color: "#1f2937",
  },
  heading: {
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "24px",
  },
  paragraph: {
    fontSize: "16px",
    marginBottom: "16px",
  },
};

export default ContactUs;